export function omitInState(state, key) {
    if (!state || !state[key]) {
        return state;
    }
    const { [key]: omited, ...newState } = state;
    return newState;
}
